import Vue from 'vue'
import data_texts from '../../data/texts.json'

// STATE
const state = {
	user: {
		best_score: 0,
		lang: 'en',
		sounds: true,
		color: 'dark',
		first_times: {
			lang: true,
			tuto: true
		}
	},
	actives: {
		options: false,
		about: false
	}
}

// GETTERS
const getters = {
	app: function(state) { return state },
	user: function(state) { return state.user },
	lang: function(state) { return state.user.lang },
	texts: function(state) { return data_texts },
}

// ACTIONS
const actions = {

	set_options_visible: function({ commit }, data) {
		commit('EDIT_ACTIVES', { options: data.visible })
	},

	set_about_visible: function({ commit }, data) {
		commit('EDIT_ACTIVES', { about: data.visible })
	},

	set_sounds: function({ commit }, data) {
		sounds.set_sounds(data.sounds)
		commit('EDIT_USER', { sounds: data.sounds })
	},

	load_data: function({ commit, state, dispatch }) {
		var data = localStorage.getItem('cards_plus_1');
		if (data) {
			commit('SET_USER', { user: JSON.parse(data) })
			if (!state.user.sounds) dispatch('set_sounds', { sounds: false })
		}
	},

	save_data: function({ state }) {
		localStorage.setItem('cards_plus_1', JSON.stringify(state.user));
	}

}

// MUTATIONS
const mutations = {
	
	SET_USER: function(state, data) {
		Vue.set(state, 'user', data.user);
	},
	
	EDIT_USER: function(state, data) {
		for (var i in data) {
			Vue.set(state.user, i, data[i]);
		}
	},
	
	EDIT_FIRST_TIMES: function(state, data) {
		for (var i in data) {
			Vue.set(state.user.first_times, i, data[i]);
		}
	},
	
	EDIT_ACTIVES: function(state, data) {
		for (var i in data) {
			Vue.set(state.actives, i, data[i]);
		}
	}

}

export default { state, getters, actions, mutations }


// WEBPACK FOOTER //
// ./src/store/modules/app.js